import React from 'react'
import PropTypes from 'prop-types'
import { Accordion,
  AccordionItem,
  AccordionItemTitle } from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/minimal-example.css'
import { AccordionComponent, AccordionBody, AccordionIcon } from './Accordion.style'

export default function Accordian({ item }) {
  return (
    <AccordionComponent>
      <Accordion>
        <AccordionItem>
          <AccordionItemTitle>
            <h6>{item.title}</h6>
            <AccordionIcon />
          </AccordionItemTitle>
          <AccordionBody>
            <div
              dangerouslySetInnerHTML={{
                __html: ((item.description || {
                }).childMarkdownRemark || {
                }).html,
              }}
            />
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </AccordionComponent>
  )
}

Accordian.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
}
